// WHY: candidate finder only — resolveByValue is the correctness authority, so an over-broad match
// that is not a loaded id resolves to 'unresolved' and is left as the raw id (cannot mis-replace).
// The two resolvable kinds are clients (keyed by their business id — the /customers id) and agreements
// (keyed by their relationship id), so `business-` and `relationship-` are the only prefixes that resolve.
// The body keeps internal hyphens but ends on an alphanumeric so a trailing hyphen in prose is not absorbed.
const CANDIDATE_ENTITY_ID = /\b(?:business|relationship)-[A-Za-z0-9_-]*[A-Za-z0-9]/g;
export const resolveSummaryText = (text, resolveByValue)=>text.replace(CANDIDATE_ENTITY_ID, (match)=>{
        const resolution = resolveByValue(match);
        return resolution.status === 'resolved' ? resolution.name : match;
    });
